import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchAlertsData } from "./api";
import { useAuth } from "./AuthContext";

const AlertsContext = createContext({ alertsCount: 0, alertsLoading: false });

export function AlertsProvider({ children }) {
  const { isAuthenticated } = useAuth();
  const [alertsCount, setAlertsCount] = useState(0);
  const [alertsLoading, setAlertsLoading] = useState(() => isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) {
      setAlertsCount(0);
      setAlertsLoading(false);
      return undefined;
    }

    let cancelled = false;
    setAlertsLoading(true);
    fetchAlertsData()
      .then((data) => {
        if (!cancelled && data?.result) {
          setAlertsCount(data.result.length);
        }
      })
      .catch((err) => console.error("Failed to fetch alerts count:", err))
      .finally(() => {
        if (!cancelled) setAlertsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated]);

  return (
    <AlertsContext.Provider value={{ alertsCount, alertsLoading }}>
      {children}
    </AlertsContext.Provider>
  );
}

export function useAlertsCount() {
  return useContext(AlertsContext).alertsCount;
}

export function useAlertsLoading() {
  return useContext(AlertsContext).alertsLoading;
}
